module["exports"] = [
  "AZ####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/address/postcode.js
// module id = 166
// module chunks = 0